import { useCallback, useEffect } from 'react';
import { KeyboardKeys } from '../enums/keyboardKeys';

interface UseArrowkeysProps {
  onLeftPress?: () => void;
  onRightPress?: () => void;
}

export const useArrowkeys = ({
  onLeftPress,
  onRightPress,
}: UseArrowkeysProps) => {
  const KEY_DOWN = 'keydown';
  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === KeyboardKeys.LEFT && onLeftPress) {
        onLeftPress();
      } else if (event.key === KeyboardKeys.RIGHT && onRightPress) {
        onRightPress();
      }
    },
    [onLeftPress, onRightPress],
  );

  useEffect(() => {
    window.addEventListener(KEY_DOWN, handleKeyPress);
    return () => {
      window.removeEventListener(KEY_DOWN, handleKeyPress);
    };
  }, [handleKeyPress]);
};
